import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fifth-meeting-first-step',
  templateUrl: './fifth-meeting-first-step.component.html',
  styleUrls: ['../../meeting-form.component.scss']
})
export class FifthMeetingFirstStepComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
